// JsFromRoutes CacheKey 1f5e1e7f45cfc9cee5296c6ca8b5cd03
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/api/workspace/:venue_slug/activities'),
}
